import { render, staticRenderFns } from "./AttendanceChatQuotedMessage.vue?vue&type=template&id=94926d64"
import script from "./AttendanceChatQuotedMessage.vue?vue&type=script&lang=js"
export * from "./AttendanceChatQuotedMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports